Auth = require 'db/auth'
_ = require 'underscore'

# When you're uploading a file using $.ajax, you need to use FormData and tell
# jQuery not to try to do its own processing on the data
#
# It's meant to be used as follows:
#
# $.ajax(_.extend({
#   url: '...'
#   ...
# }, fileUploadOptions({
#   foo: 'bar'
#   file: [ fileObject, 'filename.jpg' ]
# })))
#
# You can also pass it's return value as the options parameter to a
# Backbone Collection::create
#
module.exports = (attributes) ->
  data = new FormData()
  data.append('token', Auth.myToken())

  for key, value of attributes
    if _.isArray(value)
      data.append(key, value...)
    else
      data.append(key, value)

  data: data
  contentType: false
  processData: false
  timeout: 6 * 60 * 60 * 1000 # 6 hours



// WEBPACK FOOTER //
// ./app/scripts/network/jquery-file-upload-options.coffee